import { Environment } from "./environment.model";

export const environment: Environment = {
	production: false,
	baseUrlForCalendly: process.env["PPF_CALENDLY_BASE"]!,
	sentryUrl: process.env["PPF_SENTRY_URL"]!,
	sentryTracePropTargetFrontEnd:
		process.env["PPF_SENTRY_TRACE_PROP_TARGET_FRONT_END"]!,
	graphqlUri: process.env["PPF_GRAPHQL_URI"]!,
	googleMapsApiKey: process.env["PPF_GOOGLE_MAPS_API_KEY"]!,
	identityPoolId: process.env["PPF_IDENTITY_POOL_ID"]!,
};
